import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpResponse } from '@angular/common/http';
import { sellerApi } from '../../config';
import {
  getFileNameFromResponseContentDisposition,
  saveFile,
} from '../services/file.download.helper';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  apiURL: any;
  headerFileName: any;

  constructor(private http: HttpClient) {}

  excelDownloadFile(URL: string, fileName: string, fileNameFromHeader?: boolean): void {
    this.apiURL = URL;
    this.headerFileName = fileName;
    const options = {
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    this.http.get(this.apiURL, options).subscribe((res: any) => {
      if (fileNameFromHeader) {
        const fileName = getFileNameFromResponseContentDisposition(res);
        this.headerFileName = fileName;
      }
      saveFile(res.body, this.headerFileName);
    });
  }

  getBlobUrl(url: string): Observable<string> {
    return this.http
      .get(url, { responseType: 'blob' })
      .pipe(map((blob: Blob) => window.URL.createObjectURL(blob)));
  }

  downloadFile(url: string): Observable<void> {
    return this.http
      .get(url, {
        responseType: 'blob',
        observe: 'response',
      })
      .pipe(
        tap((res: HttpResponse<Blob>) => {
          const contentDisposition = res.headers.get('content-disposition');
          let fileName = 'downloaded-file';

          if (contentDisposition) {
            const matches = /filename="([^"]*)"/.exec(contentDisposition);
            if (matches && matches[1]) {
              fileName = matches[1];
            }
          }

          const body = res.body ? res.body : new Blob();
          const blob = new Blob([body]);
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }),
        map(() => void 0)
      );
  }
}
